import UserPlanCommissions from 'components/UserPlanCommissions/List/UserPlanCommissions';

const UserPlanCommissionsPageList = () => {
	return <UserPlanCommissions />;
};

export default UserPlanCommissionsPageList;
